var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconWarning = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "!_nw_large")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NW_B_Beta_Loan-Quotes-Desktop-Appetite-1",
    transform: "translate(-764.000000, -500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon:risk_nw_sml",
    transform: "translate(764.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CE3B57",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.499,14.134 L11.397351,14.1340244 C11.1324503,11.8083479 11,9.09700643 11,6 L11,6 L12.5,6 L12.499,14.134 Z M12.5088757,15.7656424 C13.4142012,15.7656424 14,16.4009626 14,17.4020733 C14,18.3839319 13.4319527,19 12.4911243,19 C11.5857988,19 11,18.3839319 11,17.3828212 C11,16.3817105 11.6035503,15.7656424 12.5088757,15.7656424 Z M14,6 C14,9.09700643 13.8675497,11.8083479 13.602649,14.1340244 L12.499,14.134 L12.5,6 L14,6 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_warning.0f5d2cc6.svg";
export { ForwardRef as ReactComponent };